<template>
  <span class="text-10px uppercase py-4px px-6px border-2 rounded-full" :class="colorClasses">{{ $t('upc.myServers.beta') }}</span>
</template>

<script>
export default {
  props: {
    colorClasses: {
      type: String,
      default: 'text-grey-mid border-grey-mid',
    },
  },
};
</script>
